import { Grid, Link, TextField } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { SaleType } from 'api/query/catalogue';
import { CataloguePayload } from 'api/query/catalogue/catalogue-payload';
import FormErrorMessage from 'components/form-error-message';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { CatalogueFormField, catalogueFormValidation, getCatalogueInitialState } from '..';
import { CreateSemenCatalogueProps } from './create-semen-catalogue-props';
import Button from '../../../../components/button';
import { ExportOutlinedIcon } from '../../../../components/icons/export-outlined';

/**
 * Create a semen catalogue.
 *
 * Step 1 of the create/edit semen catalogue.
 * @param props
 */
export const CreateSemenCatalogue: React.FC<CreateSemenCatalogueProps> = (props) => {
  const {
    catalogue,
    apiErrors,
  } = props;

  const {
    register, setValue, errors,
  } = useFormContext();

  const [cata] = useState<CataloguePayload>(getCatalogueInitialState(catalogue));

  /**
   * Set the sale type when the component mounts so this can be included
   * when creating the catalogue.
   */
  useEffect(() => {
    register(CatalogueFormField.SaleType);
    setValue(CatalogueFormField.SaleType, SaleType.AllSemenCatalogue);
  }, [register, setValue]);

  return (
    <Grid
      className="form-container"
      item
      xs={12}
      sm={10}
      md={6}
    >
      <div className="intro">
        <Grid
          container
          justify="center"
        >
          <p>
            Before you start, download the Semen Catalogue template. This will allow you to upload multiple
            animals details
            quickly to create your semen catalogue.<br />
            <i>Do not enter information or delete the cells that have yellow highlighting.</i>
          </p>
        </Grid>
        <Link
          className="intro__button"
          href="/Semen catalogue animal list template.xlsx"
          target="_blank"
          download
        >
          <Button
            variant="text"
            startIcon={<ExportOutlinedIcon />}
          >
            Semen Catalogue template
          </Button>
        </Link>
        <hr className="MuiDivider-root" />
      </div>
      {apiErrors.map((e) => (
        <Alert
          key={e.errorType}
          severity="error"
        >
          {e.errorMessage}
        </Alert>
      ))}
      {/** Catalogue information */}
      <div className="form-section">
        <div className="form-section__header">Catalogue information</div>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            xs={12}
          >
            {/** Catalogue Title */}
            <TextField
              label="Catalogue Title"
              defaultValue={cata.title}
              name={CatalogueFormField.Title}
              error={!!errors[CatalogueFormField.Title]}
              helperText={(
                <FormErrorMessage
                  errors={errors}
                  name={CatalogueFormField.Title}
                />
)}
              inputRef={register(catalogueFormValidation[CatalogueFormField.Title])}
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            {/** Flock Name */}
            <TextField
              label="Flock Name"
              defaultValue={cata.flock}
              name={CatalogueFormField.FlockName}
              error={!!errors[CatalogueFormField.FlockName]}
              helperText={(
                <FormErrorMessage
                  errors={errors}
                  name={CatalogueFormField.FlockName}
                />
)}
              inputRef={register(catalogueFormValidation[CatalogueFormField.FlockName])}
            />
          </Grid>
        </Grid>
      </div>
      {/** Location */}
      <div className="form-section">
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            xs={4}
          >
            {/** Postcode */}
            <TextField
              label="Stud postcode"
              type="number"
              defaultValue={cata.postcode}
              name={CatalogueFormField.Postcode}
              error={!!errors[CatalogueFormField.Postcode]}
              helperText={(
                <FormErrorMessage
                  errors={errors}
                  name={CatalogueFormField.Postcode}
                />
)}
              inputRef={register(catalogueFormValidation[CatalogueFormField.Postcode])}
            />
          </Grid>
        </Grid>
      </div>
    </Grid>
  );
};

// (CreateSemenCatalogue as any).whyDidYouRender = {
//   customName: 'CreateSemenCatalogue',
// };
